import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
// import {DragulaService} from "ng2-dragula";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {RestService} from "../immerdrin/rest.service.interface";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {InsertEditMitDialogs} from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import {AuthService} from "../../shared/auth.service";
import {LoggerService} from "../../shared/logger.service";
import {SelectFilterUtil} from "../immerdrin/select-filter.util";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http"; import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {NgxWigModule} from "ngx-wig";
import {DataTablePipeLieferantenGruppe} from "./datapipelieferantengruppe";

const PATH_FILE = 'app/protected/fragebogenverwaltung/fragebogen.insertEdit.component.ts';

@Component({
    selector: 'oase-fragebogen-insertEdit.dialog',
    templateUrl: './fragebogen.insertEdit.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, RouterModule,
	NgxMatSelectSearchModule, ReactiveFormsModule, NgxWigModule, DataTablePipeLieferantenGruppe ]

})
export class FragebogenInsertEditComponent extends InsertEditMitDialogs {

	canSubmit: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<FragebogenInsertEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dataService: RestService,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		public dialog: MatDialog,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public _logger: LoggerService) {

		super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);

		SelectFilterUtil.initFilter(this.aktuell.alleLieferantenGruppen, this.aktuell, (lg, search) => { return lg.name.toLowerCase().indexOf(search) > -1 })

	}

	setSubmit(newSubmit: boolean) {
		this.canSubmit = (this.aktuell.name !=null && this.aktuell.name !== '') &&
			this.aktuell.typ != null && this.aktuell.ablaufdatum != null &&
			(this.aktuell.lieferantenGruppen != null && this.aktuell.lieferantenGruppen.length != 0) && newSubmit;
	}

	// such comparison is needed for mat-select
	compareMitId(item1, item2) {
		return item1 && item2 ? item1.id === item2.id : item1 === item2;
	}

	specificInitHandling(aktuell: any) {
		// aktuell.tempSprachSchluessel = aktuell.sprachschluessel != null ? aktuell.sprachschluessel.replace(/^fragebogen./, '') : "";
	}

	specificPreSaveHandling(aktuell: any) {
		// aktuell.sprachschluessel = "fragebogen."+aktuell.tempSprachSchluessel;
	}

	curDate() {
		return new Date();
	}

}
